// Read dependency declarations without allocating the entire architectural model
// or an array containing every line. Source bytes remain unchanged.
export const OBJ_SOURCE_LIMIT = 1024 ** 3;
const CHUNK = 1024 ** 2;
const read = blob => blob.arrayBuffer ? blob.arrayBuffer() : new Promise((resolve, reject) => {
  const reader = new FileReader(); reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(reader.error); reader.readAsArrayBuffer(blob);
});
const scans = new WeakMap();
export function scanObj(file) {
  if (!scans.has(file)) scans.set(file, scan(file).catch(error=>{scans.delete(file);throw error;}));
  return scans.get(file);
}
async function scan(file) {
  if (!Number.isSafeInteger(file.size) || file.size < 1 || file.size > OBJ_SOURCE_LIMIT) throw new Error('OBJ source must be nonempty and at most 1 GiB.');
  let pending = '', vertices = 0, faces = 0; const decoder = new TextDecoder();
  const references = new Set();
  const line = value => {
    if (value.length > CHUNK) throw new Error('OBJ line exceeds the safe parsing limit.');
    const trimmed = value.trim();
    if (/^v\s+/.test(trimmed)) vertices++;
    if (/^f\s+/.test(trimmed)) faces++;
    const match = trimmed.match(/^mtllib\s+(.+)$/i);
    if (match) { references.add(match[1].trim()); if (references.size > 200) throw new Error('Too many OBJ material libraries.'); }
  };
  for (let offset = 0; offset < file.size; offset += CHUNK) {
    pending += decoder.decode(await read(file.slice(offset, offset + CHUNK)), {stream:true});
    let start = 0, end;
    while ((end = pending.indexOf('\n', start)) !== -1) { line(pending.slice(start, end)); start = end + 1; }
    pending = pending.slice(start);
    if (pending.length > CHUNK) throw new Error('OBJ line exceeds the safe parsing limit.');
  }
  line(pending + decoder.decode());
  // This is dependency discovery. The server admission probe and actual
  // decoder independently validate geometry before claiming it is usable.
  return { references: [...references], vertices, faces };
}
